import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import Hub from "./Hub";
import { PRICING_TABLE_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";
import BillingTypeSettings from "./BillingTypeSettings";
import ProductPresentationSettings from "./ProductPresentationSettings";
import FeatureListSettings from "./FeatureListSettings";
import ProductOrderHub from "./ProductOrderHub";
import { SchemaPropTypes } from "utils/propTypes";
import { useScrollToElement } from "utils/hooks/editor";

/**
 *
 * @param {Object} props
 * @param {String} props.name - manifest.data.content[entity-uuid]
 */
const PricingTableBlock = (props) => {
  const { name } = props;
  const { values } = useFormikContext();
  useScrollToElement(name);
  const pricingIntent = get(values, STATE_KEYS.EDITOR.PRICING_INTENT);
  let content = null;

  if (pricingIntent === PRICING_TABLE_INTENT.BILLING_TYPE) {
    content = <BillingTypeSettings name={name} />;
  } else if (pricingIntent === PRICING_TABLE_INTENT.PRODUCT_PRESENTATION) {
    content = (
      <ProductPresentationSettings name={name} scrollTop={props.scrollTop} />
    );
  } else if (pricingIntent === PRICING_TABLE_INTENT.FEATURE_LIST) {
    content = <FeatureListSettings name={name} scrollTop={props.scrollTop} />;
  } else if (pricingIntent === PRICING_TABLE_INTENT.PRODUCT_ORDER) {
    content = <ProductOrderHub {...props} />;
  } else {
    content = <Hub {...props} />;
  }

  return content;
};

PricingTableBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.shape(SchemaPropTypes)
};

export default PricingTableBlock;
